module.exports = __webpack_public_path__ + "img/taxi_demo.9253d2ea.jpg";